export default __webpack_public_path__ + "static/nofluffjobs_logo-8e898207dafdbc1b3b6d2fb1b4b376e8.jpg";